import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Card,
    CardContent,
    Typography,
    Box,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Divider,
    Skeleton,
    Button
} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link as RouterLink } from "react-router-dom";

const GibWidget = () => {
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchNews = async () => {
            try {
                const response = await axios.post(
                    `https://cors-proxy-post.onrender.com/?target=https://www.gib.gov.tr/api/gibportal/duyuru/listPublish?preview=false&page=0&size=10&sortFieldName=startdate&sortType=DESC`,
                    {
                        type: 1,
                        ilkodu: "UNIVERSAL"
                    },
                    {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                );
                console.log(response.data);
                const items = response.data?.resultContainer?.content || [];

                const newsItems = items.map(item => ({
                    title: item.title,
                    url: `https://www.gib.gov.tr/duyuru-arsivi/mevzuat/${item.slug}`,
                    date: item.startdate
                }));
                setNews(newsItems);
                setLoading(false);
            } catch (error) {
                console.error("GİB duyuruları yüklenirken hata oluştu:", error);
                setLoading(false);
            }
        };

        fetchNews();
    }, []);

    const mobileAnnouncements = news.slice(0, 3);
    const desktopAnnouncements = news.slice(0, 5);

    const renderAnnouncements = (list) => (
        <Box sx={{
            maxHeight: 330,
            overflow: "auto",
            "&::-webkit-scrollbar": {
                width: "8px",
            },
            "&::-webkit-scrollbar-track": {
                backgroundColor: "#f1f1f1",
                borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#d32f2f",
                borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#c62828",
            },
            scrollbarWidth: "thin",
            scrollbarColor: "#d32f2f #f1f1f1",
        }}>
            <List dense sx={{ padding: 0 }}>
                {list.map((item, index) => (
                    <ListItem key={index} disableGutters sx={{ py: 0.5 }}>
                        <ListItemIcon>
                            <FiberManualRecordIcon sx={{ fontSize: 6, color: "#d32f2f" }} />
                        </ListItemIcon>
                        <ListItemText>
                            <a
                                href={item.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    textDecoration: "none",
                                    color: "#333",
                                    fontSize: "13px",
                                    lineHeight: "1.4"
                                }}
                            >
                                {item.title}
                            </a>
                        </ListItemText>
                    </ListItem>
                ))}
            </List>
        </Box>
    );

    return (
        <Card sx={{ maxWidth: 380, height: { md: 450 }, borderRadius: 2, boxShadow: 2, border: "1px solid #ddd", p: 1 }}>
            <CardContent sx={{ p: 2 }}>
                <Box display="flex" alignItems="center" mb={1}>
                    <img src="/gib-logo.png" alt="GİB Logo" width={30} height={30} />
                    <Typography variant="subtitle1" color="error" fontWeight="bold" ml={1}>
                        GİB Duyuruları
                    </Typography>
                </Box>

                {loading ? (
                    <Box>
                        <Skeleton variant="text" width="80%" />
                        <Skeleton variant="text" width="90%" />
                        <Skeleton variant="text" width="75%" />
                        <Skeleton variant="text" width="85%" />
                    </Box>
                ) : (
                    <Box>
                        <Divider sx={{ my: 1 }} />

                        {/* Mobilde 3 duyuruyu göster */}
                        <Box sx={{ display: { xs: "block", sm: "none" } }}>
                            {renderAnnouncements(mobileAnnouncements)}
                        </Box>

                        {/* Büyük ekranlarda 5 duyuruyu göster */}
                        <Box sx={{ display: { xs: "none", sm: "block" } }}>
                            {renderAnnouncements(desktopAnnouncements)}
                        </Box>

                        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                            <Button
                                component={RouterLink}
                                to="/haberler/gib"
                                size="small"
                                color="error"
                                endIcon={<ArrowForwardIcon />}
                            >
                                Daha Fazla
                            </Button>
                        </Box>
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};

export default GibWidget;
